import { HOST } from "../constants/HostConstants";

export const userBan = async (user_id, reason, report_id) => {
  try {
    const res = await fetch(`${HOST}/api/comment/commentBanUser`, {
      method: "POST",
      credentials: "include",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ user_id, reason, report_id }),
    });
    const data = await res.json();
    return data;
  } catch (err) {
return { success: false, error: err.message };
  }
};
